module.exports = __webpack_public_path__ + "img/004-astronaut.e385628c.png";